import { Directive, Input, ElementRef, ViewContainerRef, OnInit, Renderer2, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { CommonService } from '@service/common.service';

@Directive({
  selector: '[appMLMText]'
})

export class MLMTextDirective {

  private mandatory = 'M';
  private enabled = 'E';
  private disabled = 'D';

  constructor(
    public renderer: Renderer2,
    public el: ElementRef,
    public viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private service: CommonService) { }

  // https://medium.com/angular-in-depth/having-fun-with-structural-directives-in-angular-69b4d229ad93
  @Input()
  set appMLMText(str: string) {
    const splitMLMText = str ? str.split('~') : [];
    if (!splitMLMText || splitMLMText.length === 0) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
      this.viewContainerRef.createEmbeddedView(this.templateRef, {
        attribute: {
          label: splitMLMText[0],
          required: splitMLMText.length >= 2 && splitMLMText[1] === this.mandatory ? true : false,
          disabled: splitMLMText.length >= 2 && splitMLMText[1] === this.disabled ? true : false
        }
      });
    }
  }

  // Below code is not acheived in angular material design
  // because its rendered dynamically during on focus of an elements and
  // we can't set attribute dynamically for our implementation,
  // as when focus happened material design will automatiically creates label from placeholder text
  // REFER: https://stackoverflow.com/questions/44307751/angular-2-material-input-change-placeholder-dynamically
  bindMLMText(str: string) {
    if (!str) {
      return null;
    }

    const formControlElement = this.el.nativeElement.querySelector('input');
    const split = str.split('~');

    if (split.length >= 1 && formControlElement) {
      this.service.setAttribute(this.renderer, formControlElement, 'placeholder', split[0]);
    }

    if (split.length >= 2 && formControlElement) {
      switch (split[1]) {
        case this.mandatory: // mandatory
          this.service.setProperty(this.renderer, formControlElement, 'required', 'true');
          break;
        case this.enabled: // enabled
          this.service.removeAttribute(this.renderer, formControlElement, 'disabled');
          break;
        case this.disabled: // disabled
          this.service.setAttribute(this.renderer, formControlElement, 'disabled', 'true');
          break;
      }
    }
  }
}
